import React from 'react';
import HomeSIngleService from '../../../../components/HomeSIngleService/HomeSIngleService';

const HomeServices = () => {
   return (
      <>
         <section className="servcies-area gray-bg pt-115 pb-90">
            <div className="container">
               <div className="row">
                  <div className="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1">
                     <div className="section-title text-center pos-rel mb-75">
                        <div className="section-icon">
                           <img className="section-back-icon" src="img/section/section-back-icon.png" alt=""/>
                        </div>
                        <div className="section-text pos-rel home_ser_title">
                           <h5>Browse our tailored care services, each designed for comfort and dignity at home with personalized attention</h5>
                           <h1>Explore Our Customized Care Services</h1>
                        </div>
                        <div className="section-line pos-rel">
                           <img src="img/shape/section-title-line.png" alt=""/>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="row">

                  <HomeSIngleService icon="1" title="Live-In & Respite Care" />
                  <HomeSIngleService icon="2" title="Alzheimer’s and Dementia Care" />
                  <HomeSIngleService icon="3" title="Hourly Care" />
                  <HomeSIngleService icon="4" title="24/7 Care" />
                  <HomeSIngleService icon="5" title="Overnight Care" />
                  <HomeSIngleService icon="6" title="Companionship" />
                  <HomeSIngleService icon="6" title="Nursing Care" />
                  <HomeSIngleService icon="6" title="Personal Support Care" />
                  <HomeSIngleService icon="6" title="Care Management" />

               </div>
            </div>
         </section>
      </>
   );
};

export default HomeServices;